<template>
  <div>
    <label class="radio-inline">
      <input
        type="radio"
        :name="id"
        :checked="valueChecked === 'true'"
        value="true"
        @change="fieldUpdated"
      />
      Sim
    </label>

    <label class="radio-inline">
      <input
        type="radio"
        :name="id"
        :checked="valueChecked === 'false'"
        value="false"
        @change="fieldUpdated"
      />
      Não
    </label>
  </div>
</template>

<script>
  import Issue from './emission-field'

  export default {
    name: 'SelectField',
    props: {
      id: {
        type: String,
        required: true
      },
      value: {
        default: '',
        required: false
      }
    },
    data() {
      return {
        fieldValue: ''
      }
    },
    computed: {
      valueChecked() {
        return this.fieldValue || this.value
      }
    },
    methods: {
      fieldUpdated($event) {
        this.fieldValue = $event.target.value

        this.$emit('input', Issue.createField(this.id, this.fieldValue, true))
      }
    }
  }
</script>
